import { render, staticRenderFns } from "./OrderTags.vue?vue&type=template&id=6b861064&scoped=true&"
import script from "./OrderTags.vue?vue&type=script&lang=js&"
export * from "./OrderTags.vue?vue&type=script&lang=js&"
import style0 from "./OrderTags.vue?vue&type=style&index=0&id=6b861064&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b861064",
  null
  
)

export default component.exports